module.exports = __webpack_public_path__ + "static/media/04 Generali Sprzęt Rolniczy Ogólne Warunki Ubezpieczenia.c0cd1e14.pdf";